import {
    FormControlLabel,
    FormGroup,
    Grid,
    TextField,
    Typography,
    Checkbox,
    checkboxClasses,
    Button,
  } from "@mui/material";
  import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
  import React from "react";
  import { useNavigate } from "react-router-dom";
  import { makeStyles } from "@mui/styles";
  import { useSelector, useDispatch } from "react-redux";
  import { sendGeneralRequest } from "../../../../features/generalRequest";
  import colors from "../../../colors";
  import { useFormik } from "formik";
  import * as yup from "yup";
  import Iframe from "react-iframe";
  import {
    setGeneralMessage,
    selectGlobalDataState,
    setTransactionHasBeenMade,
  } from "../../../../features/global/globalDataSlice";
  import {
    selectTopUpData,
    setCurrentAction,
    setShouldFetchCards,
    setShouldDisplayIFrame,
  } from "../../../../features/userInfo/topUpSlice";
  import CardList from '../cardOnFile/CardList'
  import { texts } from "../../../general/texts";

const AddNewCardFrame = () => 
{
    const dispatch = useDispatch()
    const topUpDataSliceState = useSelector(selectTopUpData)

    const getErrorMessage = (url) => 
    {
        const params = new Proxy(new URLSearchParams(url), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        if(params.errorMsg !== '')
        {
          return window.atob(params.errorMsg)
        }
        else
        {
          return texts["message-general-error"] 
        }      
    } 
    const checkBasicAccountPayment = (redirectUrl) => {
        if (redirectUrl.toLowerCase().includes("fail")) {
          dispatch(setGeneralMessage({type: "error",message: getErrorMessage(redirectUrl)}))
          dispatch(setShouldDisplayIFrame(false));
        } 
        else if (redirectUrl.toLowerCase().includes("success")) {
          dispatch(
            setGeneralMessage({
              type: "success",
              message: texts["message-success-trx"],
            })
          );
          dispatch(setTransactionHasBeenMade(true));
          dispatch(setShouldFetchCards(true));
          dispatch(setCurrentAction("makePayment"));
          dispatch(setShouldDisplayIFrame(false));
        }
        
    };
    
    const onBack = () => 
    {
        dispatch(setShouldDisplayIFrame(false));
    };

    return(
        <Grid container justifyContent={"center"} direction={"column"}>
          <Grid item>
            <Grid container>
              <Grid item md={1} xs={2}>
                <Button
                  onClick={() => {
                    onBack();
                  }}
                  sx={{ height: "4rem",
                  borderRadius: "100%",
                  "&:hover": { background: colors.white }}}
                >
                  <ArrowBackIosNewIcon color="warning" />
                </Button>
              </Grid>
            </Grid>
            <Iframe
              url={topUpDataSliceState.creditCardPaymentUrl}
              width="100%"
              height="620vh"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
              onLoad={(e) => {
                checkBasicAccountPayment(e.target.contentWindow.location.href);
              }}
            />
          </Grid>
        </Grid>
    )
}
export default AddNewCardFrame